import _, {orderBy} from "lodash";
import {transactionsType} from "../../AppConstants";
import {getCurrencyName} from "./currency";


export const map_for_pie=(portfolio) => {
    //очищаем, объединяем, сортируем данные

    console.log(portfolio, 'pie')
    const portfolio_list = _.filter(portfolio?.portfolio_list,  (item) => {return item.summa_pc > 0})
    const map_portfolio_list = _.map(portfolio_list, (val)=>{
        val.name = portfolio?.s.securities[val.security_id].ticker
        return val
    })
    const money_list = _.filter(portfolio?.money_list,  (item) => {return item.summa_pc > 0})
    const all_list = _.orderBy(_.union(map_portfolio_list, money_list),'summa_pc','desc')
    const list =_.map(all_list, 'summa_pc')
    const list_title =_.map(all_list,'name')
    return {
        list: list,
        list_title:list_title
    }
}

export const map_type=(portfolio) => {
    //очищаем, объединяем, сортируем данные

    console.log(portfolio, 'pie')
    const portfolio_list = _.filter(portfolio?.portfolio_list,  (item) => {return item.summa_pc > 0})
    const map_portfolio_list = _.map(portfolio_list, (val)=>{
        val.name = portfolio?.s.securities[val.security_id].ticker
        return val
    })
    const money_list = _.filter(portfolio?.money_list,  (item) => {return item.summa_pc > 0})
    const all_list = _.orderBy(_.union(map_portfolio_list, money_list),'summa_pc','desc')
    const list =_.map(all_list, 'summa_pc')
    const list_title =_.map(all_list,'name')
    return {
        list: list,
        list_title:list_title
    }
}
export const map_sec_history=(sec_id,transactions) => {
    let filter =  _.filter(transactions, { 'security': Number(sec_id)})
    let list = _.orderBy(filter,'dateTime','desc')
    return list
}

export const price_for_chart=(point_data,prices) => {
    //let filter =  _.filter(transactions, { 'security': Number(sec_id)})

    let price
    let val
    for (val of prices){
        if(val.date>= point_data){
            console.log(val.date,point_data)
            price = val.close
            break;
        }
    }
    return price
}

export const map_money_list = (money_list)=>{
    const filter = _.filter(money_list, function (item) {
        return item.summa_pc != 0;
    })
    return orderBy(filter,'summa_pc','desc')
}

export const map_portfolio_list = (portfolio) => {
    const map_list = _.map(portfolio.portfolio_list, (val)=>{
        val.ticker = portfolio.s.securities[val.security_id].ticker
        val.name = portfolio.s.securities[val.security_id].name
        val.icon = portfolio.s.securities[val.security_id].icon
        val.type = portfolio.s.securities[val.security_id].type
        return val
    })
    console.log(_.groupBy(map_list,'type'))
    return _.groupBy(
        orderBy(

        _.filter(map_list, function (item) {
            return item.summa_pc != 0 //&& item.type=='share';
        })
            ,
        'summa_pc',
        'desc'),
        'type'
    )
}

export const map_other_events = (portfolio) => {

    const splits = _.map(portfolio.events.splits,  (val)=>{
        val.ticker = portfolio.s.securities[val.security].ticker
        val.name = portfolio.s.securities[val.security].name
        val.icon = portfolio.s.securities[val.security].icon
        val.type = portfolio.s.securities[val.security].type
        val.type_event = 'Сплит'
        return val
    })
    const amortizations = _.map(portfolio.events.amortizations,  (val)=>{
        val.ticker = portfolio.s.securities[val.security].ticker
        val.name = portfolio.s.securities[val.security].name
        val.icon = portfolio.s.securities[val.security].icon
        val.type = portfolio.s.securities[val.security].type
        val.type_event = 'Амортизация'
        return val
    })

    const offers = _.map(portfolio.events.offers,  (val)=>{
        val.ticker = portfolio.s.securities[val.security].ticker
        val.name = portfolio.s.securities[val.security].name
        val.icon = portfolio.s.securities[val.security].icon
        val.type = portfolio.s.securities[val.security].type
        val.type_event = 'Оффер'
        return val
    })
    const events = _.map(_.union(splits,amortizations,offers),  (val,index)=>{
        val.id = index
        return val
    })

    return events
}

export const map_events = (events, securities) => {
    const map_list = _.map(events, (val,index)=>{
        val.id = index
        val.ticker = securities[val.security].ticker
        val.name = securities[val.security].name
        val.icon = securities[val.security].icon
        val.type = securities[val.security].type
        return val
    })
    return map_list
}
export const map_transactions = (portfolio) => {
    const transactions = _.map(portfolio?.transactions,  (val)=>{
        if(portfolio.s.securities[val.security]){
            val.ticker = portfolio.s.securities[val.security].ticker
            val.name = portfolio.s.securities[val.security].name
            val.icon = portfolio.s.securities[val.security].icon
            val.security_type = portfolio.s.securities[val.security].type
        }
        else{
            val.ticker = 'Деньги'
            val.name = getCurrencyName(val.currency)
            val.icon = ''
            val.security_type = 'selt'
        }
        return val
    })
    return transactions
}